/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var FlashIcon = createIcon("FlashIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: "#501002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.007 34v-8.694h8.624v-2.842h-8.624V16.64h9.772l.014-2.884H13.549V34h3.458Zm17.122.21c.462 0 1.022-.112 1.526-.28v-2.142l-.728-.028c-1.148-.098-1.638-.798-1.638-2.058V13.196h-3.332v16.898c0 2.058.42 4.116 4.172 4.116Z",
    fill: "#FF7373"
  }));
}, {
  "i18nKey": "svg.FlashIcon"
});